const m = (s, f = [], a = {}) => {
  if (!s || s.length === 0)
    return [];
  const r = s.filter((n) => Object.keys(n).length > 0);
  if (r.length === 0)
    return [];
  if (f.length === 0) {
    const n = r[0], i = n ? Object.keys(n)[0] : void 0, t = Object.values(a).find((e) => e.nameKey === i);
    return t ? [t] : [];
  }
  const l = new Set(
    r.map((n) => Object.keys(n).sort().join(","))
  ), h = [];
  for (const n of f) {
    const i = Array.isArray(n) ? n : [n], t = [], e = [];
    for (const c of i) {
      const o = a[c];
      o != null && o.nameKey && (t.push(o), e.push(o.nameKey));
    }
    if (e.length > 0) {
      const c = e.sort().join(",");
      l.has(c) && h.push(...t);
    }
  }
  return h;
};
export {
  m as filterSecurityRequirements
};
